import { intentContext, pipeline, pipelineSection } from '@/content/site'

import { Reveal } from './shared/Reveal'
import { SectionHeading } from './shared/SectionHeading'

export function PipelineSection() {
  return (
    <section id="pipeline" className="relative py-20 md:py-28">
      <div className="shell">
        <SectionHeading
          eyebrow={pipelineSection.eyebrow}
          title={pipelineSection.title}
          intro={pipelineSection.intro}
        />

        {/* Four stages. A hairline rail runs behind them on wide screens to
            read as one flow rather than four unrelated cards. */}
        <div className="relative">
          <div
            className="pointer-events-none absolute left-0 right-0 top-[3.4rem] hidden h-px lg:block"
            style={{
              background:
                'linear-gradient(90deg, transparent, rgb(255 255 255 / 0.12) 12%, rgb(255 255 255 / 0.12) 88%, transparent)',
            }}
            aria-hidden="true"
          />

          <div className="relative grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
            {pipeline.map((stage, i) => (
              <Reveal key={stage.n} i={i} className="h-full">
                <article className="glass glass-rim glass-lift flex h-full flex-col p-5 md:p-6">
                  <div className="mb-4 flex items-center gap-3">
                    <span className="flex h-7 w-7 items-center justify-center rounded-full border border-iris/30 bg-iris/10 font-mono text-[0.6rem] text-iris">
                      {stage.n}
                    </span>
                    <span className="h-px flex-1 bg-white/10" aria-hidden="true" />
                  </div>

                  <h3 className="font-sans text-[1rem] font-semibold tracking-tight text-ink">
                    {stage.name}
                  </h3>

                  <p className="mt-2 flex-1 font-paragraph text-[0.83rem] leading-relaxed text-ink-dim">
                    {stage.body}
                  </p>

                  <p className="mt-5 border-t border-white/10 pt-3 font-mono text-[0.56rem] tracking-wide text-ink-mute">
                    {stage.detail}
                  </p>
                </article>
              </Reveal>
            ))}
          </div>
        </div>

        {/* IntentContext — the distinctive bit, and the reason generation is
            not just a prompt forwarded to a model. */}
        <Reveal i={4}>
          <div className="glass glass-rim glass-hi mt-4 p-6 md:p-8">
            <div className="flex flex-wrap items-baseline gap-3">
              <p className="micro">{intentContext.label}</p>
              <span className="font-mono text-[0.56rem] tracking-wide text-ink-mute">
                derived in step 02
              </span>
            </div>

            <div className="mt-6 grid grid-cols-1 gap-6 sm:grid-cols-3">
              {intentContext.items.map((item) => (
                <div key={item.name}>
                  <h4 className="font-sans text-[0.95rem] font-semibold text-ink">{item.name}</h4>
                  <p className="mt-1.5 font-paragraph text-[0.82rem] leading-relaxed text-ink-dim">
                    {item.body}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  )
}
